import React from 'react';
import { Box } from '@availity/element';
import { themeColors } from '../../static/constants/styles';

interface SidebarSkeletonProps {
  theme: 'light' | 'dark';
}

const SidebarSkeleton = ({ theme }: SidebarSkeletonProps) => (
  <Box
    className="sidebar-skeleton"
    sx={{
      width: 280,
      bgcolor: themeColors[theme].background,
      p: '24px 16px',
      borderRight: `1px solid ${themeColors[theme].border}`,
      position: 'sticky',
      top: 0,
      height: '100vh',
      display: { xs: 'none', md: 'block' }
    }}
  >
    {/* Loading lines for sidebar items */}
    <Box className="sidebar-skeleton__line" sx={{ height: 24, bgcolor: themeColors[theme].cardBackground, mb: 2, borderRadius: '4px', width: '80%' }} />
    <Box className="sidebar-skeleton__line" sx={{ height: 24, bgcolor: themeColors[theme].cardBackground, mb: 2, borderRadius: '4px', width: '90%' }} />
    <Box className="sidebar-skeleton__line" sx={{ height: 24, bgcolor: themeColors[theme].cardBackground, mb: 2, borderRadius: '4px', width: '70%' }} />
  </Box>
);

export default SidebarSkeleton;
